export default {
  SET_PREVIOUS_ROUTE: 'SET_PREVIOUS_ROUTE',

  SET_STATUS_CODE: 'SET_STATUS_CODE',
}
